import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export const useCharacter = defineStore('character', {
  state: () => ({}),
  actions: {
    // 角色列表
    async roleList(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/role/page',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增或编辑角色
    async addOrEditRole(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/role/addOrEdit',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 角色详情
    async getRoleInfo(id: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/role/getRoleInfo/${id}`,
          method: 'get'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取角色下用户
    async getUserByRole(id: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/role/getUserByRole/${id}`,
          method: 'get'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除角色
    async deleteRoleInfo(id: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/role/delete/${id}`,
          method: 'post'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取所有菜单树
    async getAllTreeMenu() {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/role/getAllTreeMenu',
          method: 'get'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 获取区域微树
    async getAreaMicroTree(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/role/getAreaMicroTree',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
